import { Pipe, PipeTransform } from '@angular/core';
import { DateFormat, SBDate, SBTime, TimeFormat } from '../date-time/sb-date-time';

@Pipe({
    name: 'formatDateTime'
})
export class LocalizationDateTimePipe implements PipeTransform {

    transform(value: string | null, pattern1: DateFormat, pattern2: TimeFormat) : string {
        if (!value) {
            return '';
        }

        try {
            return SBDate.FromISO(value!).Render(pattern1) + ' ' + SBTime.FromISO(value).Render(pattern2).replace(/\s/g, '\u00A0');
        } catch {
            return '';
        }
    }
}
